import * as React from 'react';

type FavoriteContentProps = {
	title?: string;
	text?: string;
	icon?: string;
};

const FavoriteContent = ({ title, text }: FavoriteContentProps) => {
	return (
		<div className="m-favorite-content">
			<div className="container">
				<div className="row">
					<div className="col-xs-12 col-md-7">
						{title && <h4 className="m-favorite-content__title">{title}</h4>}
						<div className="m-favorite-content__text">
							{text && (
								<p
									className="m-favorite-content__text"
									dangerouslySetInnerHTML={{
										__html: text,
									}}
								/>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export { FavoriteContent };
export default FavoriteContent;
